import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment as ENV } from '@environment/environment';

import { IPodcastContent, IPodcastViewModel } from '@interfaces/i-podcast-view-model';
import {IPodcastResponseSoa } from '@interfaces/i-podcast-response-soa';
import { IPagingRequestModel, IPagingRequestModelSoa } from '@interfaces/ipaging-request-model';

@Injectable({
  providedIn: 'root',
})
export class PodcastV3Service {

  private API = `${ENV.webApi}v2/podcast`;
  private APISOA = `${ENV.soaApiBaseUrl}podcast`;

  constructor(private http: HttpClient) {}

  public view(podcastId:string, page:number): Observable<any> {
    const url = `${this.APISOA}/${podcastId}/items/${page}`;
    return this.http.get<any>(url);
  }

  public generalInfo(podcastId:string): Observable<IPodcastResponseSoa> {
    const url = `${this.APISOA}/${podcastId}/play`;
    return this.http.get<any>(url);
  }

  public viewRecommended(): Observable<IPodcastViewModel[]> {
    const url = `${this.API}/view/recommended`;
    return this.http.get<IPodcastViewModel[]>(url);
  }

  public getPodcastParent(podcastItemId: string): Observable<IPodcastContent> {
    const url = `${this.API}/view/podcastItem/${podcastItemId}`;
    return this.http.get<IPodcastContent>(url);
  }

}
